import { ReimbursementAccountAddress } from '@/app/pages/reimbursements/accounts/new/AccountAddress'
import { ReimbursementAccountDetail } from '@/app/pages/reimbursements/accounts/new/AccountDetail'
import { ReimbursementAccountLinked } from '@/app/pages/reimbursements/accounts/new/AccountLinked'
import { ReimbursementAccountNumber } from '@/app/pages/reimbursements/accounts/new/AccountNumber'
import { ReimbursementAccountBankName } from '@/app/pages/reimbursements/accounts/new/BankName'
import { ReimbursementAccountNickName } from '@/app/pages/reimbursements/accounts/new/NickName'
import { ReimbursementRoutingNumber } from '@/app/pages/reimbursements/accounts/new/RoutingNumber'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { RouteObject } from 'react-router-dom'


export const REIMBURSEMENT_ACCOUNT_ROUTES: RouteObject[] = [
  {
    path: AppRoutePaths.reimbursements.accounts.link.index,
    element: <ReimbursementAccountAddress />,
  },
  {
    path: AppRoutePaths.reimbursements.accounts.link.address,
    element: <ReimbursementAccountAddress />,
  },
  {
    path: AppRoutePaths.reimbursements.accounts.link.account_number,
    element: <ReimbursementAccountNumber />,
  },
  {
    path: AppRoutePaths.reimbursements.accounts.link.routing_number,
    element: <ReimbursementRoutingNumber />,
  },
  {
    path: AppRoutePaths.reimbursements.accounts.link.bank,
    element: <ReimbursementAccountBankName />,
  },
  {
    path: AppRoutePaths.reimbursements.accounts.link.detail,
    element: <ReimbursementAccountDetail />,
  },
  {
    path: AppRoutePaths.reimbursements.accounts.link.nickname,
    element: <ReimbursementAccountNickName />,
  },
  {
    path: AppRoutePaths.reimbursements.accounts.link.complete,
    element: <ReimbursementAccountLinked />,
  },
]
